<template>
  <div class="app-body">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" class="query-form">
      <el-form-item label="供应商：">
        <el-input v-model="dataForm.companyName" size="mini" clearable></el-input>
      </el-form-item>
      <el-form-item label="账号：">
        <el-input v-model="dataForm.username" size="mini" :placeholder="$t('user.username')" clearable></el-input>
      </el-form-item>
      <el-form-item label="姓名：">
        <el-input v-model="dataForm.realName" size="mini" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="getDataList()" size="mini">{{ $t('query') }}</el-button>
      </el-form-item>
      <el-form-item>
        <el-button v-if="$hasPermission('erp:company:user:create')" size="mini" type="primary" @click="showSave()">
          创建账号
        </el-button>
      </el-form-item>
    </el-form>
    <SweetTable ref="table" url="/sys/user/company" delete-url="/sys/user" :query-form="dataForm">
      <el-table-column prop="companyName" label="供应商" header-align="center"
                       align="center"></el-table-column>
      <el-table-column prop="username" :label="$t('user.username')" header-align="center"
                       align="center"></el-table-column>
      <el-table-column prop="realName" label="姓名" header-align="center" align="center"></el-table-column>
      <el-table-column prop="mobile" :label="$t('user.mobile')" header-align="center"
                       align="center"></el-table-column>
      <el-table-column prop="status" :label="$t('user.status')" header-align="center"
                       align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 0" size="small" type="danger">{{ $t('user.status0') }}</el-tag>
          <el-tag v-else size="small" type="success">{{ $t('user.status1') }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createDate" :label="$t('user.createDate')" header-align="center"
                       align="center" width="180"></el-table-column>
      <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="200">
        <template slot-scope="scope">
          <el-button v-if="$hasPermission('sys:user:update')" type="text" size="small"
                     icon="el-icon-edit-outline"
                     @click="showSave(scope.row)">{{ $t('update') }}
          </el-button>
          <el-button v-if="$hasPermission('sys:user:delete')" type="text" size="small"
                     icon="el-icon-close"
                     @click="doDelete(scope.row)">{{ $t('delete') }}
          </el-button>
          <el-button v-if="$hasPermission('sys:user:reset')" type="text" size="small"
                     icon="el-icon-refresh"
                     @click="resetPass(scope.row)">重置密码
          </el-button>
        </template>
      </el-table-column>
    </SweetTable>
    <Save ref="Save" @refreshDataList="getDataList"></Save>
  </div>
</template>

<script>
import SweetTable from '@/mixins/SweetTable'
import Save from './save.vue'

export default {
  mixins: [SweetTable],
  data () {
    return {
      dataForm: {
        username: '',
        realName: '',
        companyName: ''
      }
    }
  },
  components: { Save },
  methods: {
    showSave (row) {
      if (row && row.id) {
        this.$refs.Save.dataForm.id = row.id
      }
      this.$refs.Save.init()
    },
    resetPass (row) {
      this.$confirm(`是否要重置供应商用户【${row.realName}】的密码为默认密码（123456）？`, '操作提示').then(() => {
        this.$api.post(`/sys/user/reset/password`, { id: row.id }).then(res => {
          this.$message.success('操作成功')
        })
      })
    }
  }
}
</script>
